module.exports = __webpack_public_path__ + "static/gloom_weaver-828afc30469ac917f9f90bcb2ad82ae6.png";